import React from 'react'

import { Helmet } from 'react-helmet'

import './contact.css'

const Contact = (props) => {
  return (
    <div className="contact-container">
      <Helmet>
        <title>
          Contact - FutureHeirs | Faith-Based Non-Profit Empowering Future
          Leaders
        </title>
        <meta
          name="description"
          content="Faith-based non-profit bridging quality education and accessibility. Empowering children through Christ-centered learning, tech literacy &amp; character development"
        />
        <meta
          property="og:title"
          content="Contact - FutureHeirs | Faith-Based Non-Profit Empowering Future Leaders"
        />
        <meta
          property="og:description"
          content="Bridging quality education and accessibility through Christ-centered learning. Empowering every child to flourish in their unique calling with faith and innovation."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/97765a8c-e132-4703-821d-7a550778f912/2688ccf9-cb16-49f3-aba4-ad25e1010654?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <div className="contact-contact-us">
        <div className="contact-frame121">
          <div className="contact-frame14">
            <div className="contact-frame162">
              <img
                alt="VectorI339"
                src="/external/vectori339-jh82.svg"
                className="contact-vector10"
              />
              <span className="contact-text10">futureheirs</span>
            </div>
            <div className="contact-frame81">
              <div className="contact-frame6">
                <span className="contact-text11">Home</span>
              </div>
              <div className="contact-frame7">
                <span className="contact-text12">About Us</span>
              </div>
              <div className="contact-frame82">
                <span className="contact-text13">Contact Us</span>
              </div>
              <div className="contact-frame9">
                <span className="contact-text14">Blog</span>
              </div>
            </div>
            <div className="contact-component41">
              <span className="contact-text15">Join Us</span>
            </div>
          </div>
          <div className="contact-frame131">
            <div className="contact-frame195">
              <img
                alt="Line653392"
                src="/external/line653392-p85.svg"
                className="contact-line65"
              />
              <span className="contact-text16">Contact Us</span>
            </div>
            <span className="contact-text17">
              Have questions or need assistance? Get in touch with us—we’re here
              to help!
            </span>
          </div>
        </div>
        <img
          alt="Rectangle43392"
          src="/external/rectangle43392-tmok.svg"
          className="contact-rectangle4"
        />
        <div className="contact-frame3045">
          <div className="contact-frame30441">
            <div className="contact-frame145">
              <div className="contact-frame17">
                <div className="contact-frame21">
                  <span className="contact-text18">Get in Touch</span>
                </div>
                <span className="contact-text19">
                  We&apos;d love to hear from you! Whether you&apos;re
                  interested in learning more about our programs, exploring
                  partnership opportunities, or simply want to connect with our
                  team, we&apos;re here to help. Choose the method that works
                  best for you, and we&apos;ll respond promptly.
                </span>
              </div>
              <div className="contact-frame143">
                <div className="contact-frame16">
                  <div className="contact-frame191">
                    <div className="contact-group391">
                      <img
                        alt="Ellipse13392"
                        src="/external/ellipse13392-kv3-200h.png"
                        className="contact-ellipse11"
                      />
                      <div className="contact-vuesaxboldsms1">
                        <div className="contact-vuesaxboldsms2">
                          <div className="contact-sms1">
                            <img
                              alt="Vector3442"
                              src="/external/vector3442-ztwr.svg"
                              className="contact-vector11"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <span className="contact-text20">Email</span>
                  </div>
                  <span className="contact-text21">info@futureheirs.org</span>
                </div>
                <div className="contact-frame192">
                  <div className="contact-frame193">
                    <div className="contact-group401">
                      <img
                        alt="Ellipse13442"
                        src="/external/ellipse13442-69f-200h.png"
                        className="contact-ellipse12"
                      />
                      <div className="contact-vuesaxboldbuliding1">
                        <div className="contact-vuesaxboldbuliding2">
                          <div className="contact-buliding">
                            <img
                              alt="Vector3442"
                              src="/external/vector3442-wh5e.svg"
                              className="contact-vector12"
                            />
                            <img
                              alt="Vector3442"
                              src="/external/vector3442-tgzb.svg"
                              className="contact-vector13"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <span className="contact-text22">Address</span>
                  </div>
                  <span className="contact-text23">
                    123 Faith &amp; Innovation Way, Your City, State 12345
                  </span>
                </div>
                <div className="contact-frame18">
                  <div className="contact-frame194">
                    <div className="contact-group402">
                      <img
                        alt="Ellipse13442"
                        src="/external/ellipse13442-n9ju-200h.png"
                        className="contact-ellipse13"
                      />
                      <div className="contact-vuesaxboldcall1">
                        <div className="contact-vuesaxboldcall2">
                          <div className="contact-call1">
                            <img
                              alt="Vector3442"
                              src="/external/vector3442-36wl.svg"
                              className="contact-vector14"
                            />
                            <img
                              alt="Vector3442"
                              src="/external/vector3442-rhwe.svg"
                              className="contact-vector15"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <span className="contact-text24">Phone</span>
                  </div>
                  <span className="contact-text25">(555) 123-4567</span>
                </div>
              </div>
            </div>
            <div className="contact-frame3010">
              <span className="contact-text26">Connect With Our Team</span>
              <div className="contact-frame3009">
                <img
                  alt="authenticsmallyouthfulmarketingagency13532"
                  src="/external/authenticsmallyouthfulmarketingagency13532-c6h-400w.png"
                  className="contact-authenticsmallyouthfulmarketingagency1"
                />
                <div className="contact-frame3034">
                  <div className="contact-frame3007">
                    <div className="contact-connectwithourteam1">
                      <span className="contact-text27">
                        Program Information
                      </span>
                      <span className="contact-text28">
                        Have questions about our educational programs? Want to
                        learn more about enrollment options for your child or
                        school?
                      </span>
                    </div>
                    <div className="contact-component91">
                      <span className="contact-text29">
                        Volunteer Opportunities
                      </span>
                      <span className="contact-text30">
                        Interested in sharing your skills and passion with the
                        next generation?
                      </span>
                    </div>
                  </div>
                  <div className="contact-frame3008">
                    <div className="contact-connectwithourteam2">
                      <span className="contact-text31">
                        Partnership &amp; Collaboration
                      </span>
                      <span className="contact-text32">
                        For schools, churches, community organizations, and
                        businesses interested in partnering with FutureHeirs:
                      </span>
                    </div>
                    <div className="contact-component92">
                      <span className="contact-text33">Donation Inquiries</span>
                      <span className="contact-text34">
                        Questions about how to give or how your donation will be
                        used:
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="contact-frame3042">
              <div className="contact-frame30431">
                <span className="contact-text35">Request a Presentation</span>
                <span className="contact-text36">
                  Interested in having a FutureHeirs representative speak at
                  your school, church, or community event? We&apos;d be happy to
                  share about our work and how it&apos;s impacting young lives.
                </span>
              </div>
              <div className="contact-component42">
                <span className="contact-text37">Request a Speaker Form</span>
              </div>
            </div>
            <div className="contact-frame3040">
              <div className="contact-frame3038">
                <div className="contact-frame3036">
                  <span className="contact-text38">Send Us a Message</span>
                  <span className="contact-text39">
                    Have a question or comment? Fill out the form, and a member
                    of our team will get back to you as soon as possible.
                  </span>
                </div>
                <div className="contact-frame3037">
                  <div className="contact-frame2071">
                    <span className="contact-text40">Follow Us</span>
                    <span className="contact-text41">
                      Connect with us on social media for regular updates and
                      inspiration:
                    </span>
                  </div>
                  <img
                    alt="Line663592"
                    src="/external/line663592-tlr3.svg"
                    className="contact-line66"
                  />
                  <div className="contact-frame3041">
                    <div className="contact-frame2061">
                      <div className="contact-frame2031">
                        <div className="contact-vuesaxboldfacebook1">
                          <div className="contact-vuesaxboldfacebook2">
                            <div className="contact-facebook1">
                              <img
                                alt="Vector3592"
                                src="/external/vector3592-s0yw.svg"
                                className="contact-vector16"
                              />
                            </div>
                          </div>
                        </div>
                        <span className="contact-text42">Facebook</span>
                      </div>
                    </div>
                    <div className="contact-frame208">
                      <div className="contact-frame2032">
                        <img
                          alt="fa6brandssquarextwitter3592"
                          src="/external/fa6brandssquarextwitter3592-zw9g.svg"
                          className="contact-fa6brandssquarextwitter1"
                        />
                        <span className="contact-text43">Twitter</span>
                      </div>
                    </div>
                    <div className="contact-frame209">
                      <div className="contact-frame2033">
                        <img
                          alt="riinstagramfill3592"
                          src="/external/riinstagramfill3592-f8hy.svg"
                          className="contact-riinstagramfill1"
                        />
                        <span className="contact-text44">Instagram</span>
                      </div>
                    </div>
                    <div className="contact-frame210">
                      <div className="contact-frame2034">
                        <img
                          alt="pajamaslinkedin3592"
                          src="/external/pajamaslinkedin3592-zpb6.svg"
                          className="contact-pajamaslinkedin1"
                        />
                        <span className="contact-text45">LinkedIn</span>
                      </div>
                    </div>
                    <div className="contact-frame211">
                      <div className="contact-frame2035">
                        <div className="contact-vuesaxboldyoutube1">
                          <div className="contact-vuesaxboldyoutube2">
                            <div className="contact-youtube1">
                              <img
                                alt="Vector3592"
                                src="/external/vector3592-htqn.svg"
                                className="contact-vector17"
                              />
                            </div>
                          </div>
                        </div>
                        <span className="contact-text46">YouTube</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="contact-frame3013">
                <div className="contact-frame2051">
                  <div className="contact-frame2062">
                    <div className="contact-frame2036">
                      <span className="contact-text47">Name</span>
                      <div className="contact-frame2021">
                        <span className="contact-text48">Owolabi Taiwo</span>
                      </div>
                    </div>
                    <div className="contact-frame204">
                      <span className="contact-text49">Email</span>
                      <div className="contact-frame2022">
                        <span className="contact-text50">
                          example@gmail.com
                        </span>
                      </div>
                    </div>
                    <div className="contact-frame2063">
                      <span className="contact-text51">Phone</span>
                      <div className="contact-frame2023">
                        <span className="contact-text52">
                          example@gmail.com
                        </span>
                      </div>
                    </div>
                    <div className="contact-frame2072">
                      <span className="contact-text53">Subject</span>
                      <div className="contact-frame2024">
                        <span className="contact-text54">
                          example@gmail.com
                        </span>
                      </div>
                    </div>
                    <div className="contact-frame2052">
                      <span className="contact-text55">Message</span>
                      <div className="contact-frame2025">
                        <span className="contact-text56">
                          Write question...
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="contact-component43">
                    <span className="contact-text57">Submit now</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="contact-frame30442">
              <div className="contact-group392">
                <img
                  alt="Rectangle19304"
                  src="/external/rectangle19304-hzn-1100w.png"
                  className="contact-rectangle1"
                />
                <div className="contact-grid">
                  <div className="contact-group34">
                    <img
                      alt="Line519304"
                      src="/external/line519304-cxmv.svg"
                      className="contact-line51"
                    />
                    <img
                      alt="Line529304"
                      src="/external/line529304-66wm.svg"
                      className="contact-line52"
                    />
                    <img
                      alt="Line539304"
                      src="/external/line539304-2gxjl.svg"
                      className="contact-line53"
                    />
                    <img
                      alt="Line549304"
                      src="/external/line549304-mkt.svg"
                      className="contact-line54"
                    />
                    <img
                      alt="Line559304"
                      src="/external/line559304-9lzm.svg"
                      className="contact-line55"
                    />
                    <img
                      alt="Line569304"
                      src="/external/line569304-sq1.svg"
                      className="contact-line56"
                    />
                    <img
                      alt="Line579304"
                      src="/external/line579304-p9un.svg"
                      className="contact-line57"
                    />
                  </div>
                  <div className="contact-group33">
                    <img
                      alt="Line369304"
                      src="/external/line369304-av3s.svg"
                      className="contact-line36"
                    />
                    <img
                      alt="Line379304"
                      src="/external/line379304-wr5u.svg"
                      className="contact-line37"
                    />
                    <img
                      alt="Line389304"
                      src="/external/line389304-tryk.svg"
                      className="contact-line38"
                    />
                    <img
                      alt="Line399304"
                      src="/external/line399304-p3hg.svg"
                      className="contact-line39"
                    />
                  </div>
                </div>
                <img
                  alt="childrenelectronicdevicesgadgetsconceptsmartconfid9304"
                  src="/external/childrenelectronicdevicesgadgetsconceptsmartconfid9304-rp2a-500h.png"
                  className="contact-childrenelectronicdevicesgadgetsconceptsmartconfid"
                />
              </div>
              <div className="contact-frame122">
                <div className="contact-frame132">
                  <span className="contact-text58">
                    Subscribe to our Newsletter
                  </span>
                  <span className="contact-text59">
                    Join our community of supporters and stay updated on how
                    we&apos;re empowering the next generation of leaders.
                  </span>
                </div>
                <div className="contact-cta">
                  <div className="contact-frame3">
                    <span className="contact-text60">example@gmail.com</span>
                  </div>
                  <div className="contact-component44">
                    <span className="contact-text61">Subscribe</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="contact-frame30432">
              <div className="contact-frame30433">
                <span className="contact-text62">Visit Our Learning Hubs</span>
                <span className="contact-text63">
                  Interested in seeing our work firsthand? We welcome visitors
                  to our Community Learning Hubs and Tech Innovation Centers by
                  appointment.
                </span>
              </div>
              <div className="contact-component45">
                <span className="contact-text64">Schedule a Visit</span>
              </div>
            </div>
          </div>
          <div className="contact-frame189">
            <div className="contact-frame184">
              <div className="contact-group107">
                <span className="contact-text65">Company</span>
                <div className="contact-frame2491">
                  <span className="contact-text66">Home</span>
                  <span className="contact-text67">About Us</span>
                  <span className="contact-text68">Contact Us</span>
                  <span className="contact-text69">Programs</span>
                  <span className="contact-text70">Approach</span>
                </div>
              </div>
              <div className="contact-group106">
                <span className="contact-text71">Quick Links</span>
                <div className="contact-frame2492">
                  <span className="contact-text72">Partner with Us</span>
                  <span className="contact-text73">Volunteer</span>
                  <span className="contact-text74">Donate</span>
                  <span className="contact-text75">Blog</span>
                </div>
              </div>
              <div className="contact-group105">
                <span className="contact-text76">Terms and Policies</span>
                <div className="contact-frame248">
                  <span className="contact-text77">Privacy Policy</span>
                  <span className="contact-text78">Terms and Conditions</span>
                  <span className="contact-text79">Feedback</span>
                  <span className="contact-text80">FAQs</span>
                </div>
              </div>
              <div className="contact-group104">
                <span className="contact-text81">Contact Information</span>
                <div className="contact-group87">
                  <span className="contact-text82">
                    connect@futureheirs.org
                  </span>
                  <div className="contact-vuesaxboldsms3">
                    <div className="contact-vuesaxboldsms4">
                      <div className="contact-sms2">
                        <img
                          alt="VectorI339"
                          src="/external/vectori339-w4l.svg"
                          className="contact-vector18"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="contact-group88">
                  <span className="contact-text83">
                    123 Faith &amp; Innovation Way, Your City, State 12345
                  </span>
                  <div className="contact-vuesaxboldlocation1">
                    <div className="contact-vuesaxboldlocation2">
                      <img
                        alt="VectorI339"
                        src="/external/vectori339-n0dc.svg"
                        className="contact-vector19"
                      />
                    </div>
                  </div>
                </div>
                <div className="contact-group89">
                  <span className="contact-text84">(555) 123-4567</span>
                  <div className="contact-vuesaxboldcall3">
                    <div className="contact-vuesaxboldcall4">
                      <div className="contact-call2">
                        <img
                          alt="VectorI339"
                          src="/external/vectori339-cv65.svg"
                          className="contact-vector20"
                        />
                        <img
                          alt="VectorI339"
                          src="/external/vectori339-4db.svg"
                          className="contact-vector21"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img
              alt="Line2I339"
              src="/external/line2i339-p5l.svg"
              className="contact-line2"
            />
            <div className="contact-frame183">
              <div className="contact-frame161">
                <img
                  alt="VectorI339"
                  src="/external/vectori339-iuvr.svg"
                  className="contact-vector22"
                />
                <span className="contact-text85">futureheirs</span>
              </div>
              <div className="contact-frame180">
                <span className="contact-text86">Follow Us:</span>
                <div className="contact-frame177">
                  <div className="contact-vuesaxboldfacebook3">
                    <div className="contact-vuesaxboldfacebook4">
                      <div className="contact-facebook2">
                        <img
                          alt="VectorI339"
                          src="/external/vectori339-pj5c.svg"
                          className="contact-vector23"
                        />
                      </div>
                    </div>
                  </div>
                  <img
                    alt="riinstagramfillI339"
                    src="/external/riinstagramfilli339-n8ak.svg"
                    className="contact-riinstagramfill2"
                  />
                  <img
                    alt="pajamaslinkedinI339"
                    src="/external/pajamaslinkedini339-zhjh.svg"
                    className="contact-pajamaslinkedin2"
                  />
                  <img
                    alt="fa6brandssquarextwitterI339"
                    src="/external/fa6brandssquarextwitteri339-alvp.svg"
                    className="contact-fa6brandssquarextwitter2"
                  />
                  <div className="contact-vuesaxboldyoutube3">
                    <div className="contact-vuesaxboldyoutube4">
                      <div className="contact-youtube2">
                        <img
                          alt="VectorI339"
                          src="/external/vectori339-5fk8.svg"
                          className="contact-vector24"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact
